import api from '.';
import { buildParams } from '../helpers/tableUtil';

class User {
  static async getUsers({ limit, page, orderData, countryFilter }) {
    const params = buildParams({ limit, page, orderData, countryFilter });
    const users = await api.get(`/user${params}`);
    return users.data;
  }

  static async createUser(data) {
    const user = await api.post('/user', data);
    return user?.data;
  }

  static async getUser(id: string) {
    const user = await api.get(`/user/${id}`);
    return user?.data;
  }

  static async updateUser(id: string, data) {
    delete data.id;
    const user = await api.put(`/user/${id}`, data);
    return user?.data;
  }
}

export default User;
